/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestFullResponse } from '../../models/harvest-full-response';

export interface GetHarvestFullResponse$Params {
  harvestId: number;
}

export function getHarvestFullResponse(http: HttpClient, rootUrl: string, params: GetHarvestFullResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestFullResponse>> {
  const rb = new RequestBuilder(rootUrl, getHarvestFullResponse.PATH, 'get');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestFullResponse>;
    })
  );
}

getHarvestFullResponse.PATH = '/api/harvests/{harvestId}';
